import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left-long",
  "use": "icon-arrow--left-long-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"icon-arrow--left-long\"><path d=\"m4.024 16.164 8.438 8.437a.938.938 0 0 0 1.326-1.326L6.95 16.438h18.363a.937.937 0 1 0 0-1.875H6.95l6.838-6.837A.938.938 0 0 0 12.462 6.4l-8.438 8.437a.938.938 0 0 0 0 1.327Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol